import { pick, isEqual } from 'underscore';
import { FIXED, MOBILE } from 'AppSrc/core/components/forms/value-dependency-constants';
import {
  MOBILE_HAPPY_PATH_ANSWERS,
  FIXED_HAPPY_PATH_ANSWERS,
  CAUSE_AN_INCIDENT,
  FOLLOW_APPROVED_PLAN,
  CHANGE_REGRESSED,
  COMPLETE_WITHIN_APPROVED_WINDOW,
  DELIVER_EXPECTED_BENEFITS,
  IMPACTED_INVENTORY_UPDATED,
  // ADDITIONAL_IMPACT,
} from 'AppSrc/core/components/forms/form-types/completion-review/form-definition/section-constants';

const getSectionFieldIds = (section) => {
  const ids = section.map((field) => {
    const {
      componentData,
    } = field;

    const {
      id,
    } = componentData;
    return id;
  });
  return ids;
};

const getPostChangeType = ({
  values, network,
}) => {
  const ids = [
    CAUSE_AN_INCIDENT,
    FOLLOW_APPROVED_PLAN,
    CHANGE_REGRESSED,
    COMPLETE_WITHIN_APPROVED_WINDOW,
    DELIVER_EXPECTED_BENEFITS,
  ];
  let fields = [];
  let happy;
  if (network === FIXED) {
    fields.push(...ids, IMPACTED_INVENTORY_UPDATED);
    happy = FIXED_HAPPY_PATH_ANSWERS;
  }
  if (network === MOBILE) {
    fields = ids;
    happy = MOBILE_HAPPY_PATH_ANSWERS;
  }
  const pickAnswers = pick(values, fields);
  if (network === FIXED) {
    happy.impacted_inventory_updated[0] = '10';
  }
  if (network === FIXED && pickAnswers.impacted_inventory_updated[0] === undefined) {
    happy.impacted_inventory_updated[0] = undefined;
  }
  const isHappyPath = isEqual(pickAnswers, happy);
  if (network === MOBILE) {
    return isHappyPath ? 'Successful' : 'Unsuccessful';
  }
  if (network === FIXED) {
    return isHappyPath ? '5000' : '6200';
  }
  return null;
};

export {
  getSectionFieldIds,
  getPostChangeType,
};
